export default {
  en: {
    translation: {
      welcome: 'Back-Office Unipar',
      customer: 'Customer',
      myOrder: 'All Orders',
      financial: 'Price',
      logout: 'Logout',
      drakMode: 'Drak Mode',
      home: 'Order Intents',
      reports: 'Reports',
      config: 'Configurations',
      users: 'Users',
      usersBack: 'BackOffice Users',
      customers: 'Customers',
      applyFilter: 'Apply filters',
      filterData: 'Filter data',
      period: 'Period',
      select: 'Select',
      products: 'Products',
      totalOrders: 'Total orders',
      cancelledOrders: 'Cancelled orders',
      updatedOrders: 'Updated orders',
      viewingData: 'Viewing data',
      exportOrders: 'Export orders',
      exportCustomers: 'Export customers',
      byProducts: 'By Products',
      origin: 'Origin',
      orders: 'Orders',
      customersSurveyReport: 'NPS CSAT Feedbacks',
      searchNotFound: 'No results were found for the search performed!',
      configurations: 'Configurations',
      office: 'Office',
      factory: 'Factory',
      new: 'New',
      edit: 'Edit',
      remove: 'Remove',
      actions: 'Actions',
      interval: 'Interval',
      intervalAll: 'All',
      createdAt: 'Created At',
      search: 'Search',
      noResults: 'No results were found',
      attachFile: 'Attach file',
      addFile: 'Add file',
      permittedFiles: 'Permitted Files: ',
      attachments: 'Attachments',
      fileRemoveModalTitle: 'Do you want to remove file?',
      close: 'Close',
      confirm: 'Confirm',
      description: 'Description',
      country: 'Country',
      type: 'Type',
      year: 'Year',
      dates: 'Dates',
      removeConfirmation: 'Do you confirm the removal of this record?',
      yes: 'Yes',
      no: 'No',
      errorSave: 'Error saving. Try again.',
      successSave: 'Record updated successfully!',
      validateType: 'It is mandatory to provide a type.',
      validateCountry: 'It is mandatory to provide a country.',
      validateYear: 'It is mandatory to provide a year.',
      validateFactory: 'It is mandatory to provide a factory.',
      validateDescription: 'It is mandatory to provide a description.',
      validateDates: 'It is mandatory to provide a date or dates.',
      save: 'Save',
      back: 'Back',
      group: 'Group',
      all: 'All',
      send: 'Send',
      fieldErrorMandatoryMessage: 'Field is mandatory',
      errorSearchMessage: 'Error getting data',
      errorRemoveMessage: 'Error removing data',
      exportXLS: 'Export XLS',
      report: {
        totalOrders: 'Total orders',
        orders: 'orders',
        portal: 'Web'
      },
      reportOrigin: {
        sap: 'SAP',
        general: 'General',
        web: 'Web'
      },
      reportMaterialType: {
        pvc: 'PVC',
        chemical: 'Chemicals'
      },
      periodAlert: {
        periodRequired: 'Period is required.',
        periodNinetyDays: 'Maximum period must be 90 days.',
        invalidDate: 'Invalid date.'
      },
      links: 'Useful links',
      link: {
        newLink: 'New link',
        editLink: 'Edit Link',
        searchFields: 'Search by title,description or link',
        search: 'Search',
        selectAll: 'All',
        active: 'Active',
        inactive: 'Inactive',
        labelCreateLink: 'Create link',
        labelLinks: 'Links',
        labelTitle: 'Title',
        labelDescription: 'Text',
        labelTitleEN: 'English Title',
        labelTitlePT: 'Portuguese Title',
        labelTitleES: 'Spanish Title',
        labelDescriptionEN: 'English Text',
        labelDescriptionPT: 'Portuguese Text',
        labelDescriptionES: 'Spanish Text',
        labelLink: 'Link',
        selectStatusActive: 'Active',
        selectStatusInactive: 'Inactive',
        labelSelect: 'Select',
        labelStatus: 'Status',
        labelCountry: 'Country',
        errorTitle: 'It is mandatory to provide the link.',
        errorDescription: 'It is mandatory to provide all descriptions.',
        errorLink: 'It is mandatory to provide the link.',
        errorCountry: 'Select a country.',
        createdTitle: 'Link creaUser created successfully!',
        createdMsg: 'The link is visible on the customer\'s website.',
        createError: 'An error has occurred',
        editedTitle: 'Link edited successfully!',
      },
      notificationMenu: 'Informatives',
      login: {
        title: 'Unipar Back-Office',
        subtitle: 'Our purpose is to be trustworthy in all our relations',
        login: 'Login',
        forgotPass: 'Forgot my password',
        register: 'First access',
        pass: 'Password',
        passValidation: 'Please, type your password',
        emailValidation: 'Please, type your e-mail',
        robotBtn: 'I am not a robot',
        notauthentication: 'Not authenticated, please wait...',
        authentication: 'Authenticating...'
      },
      homeWidgets: {
        newOrderTitle: 'Place a new order',
        newOrderSubTitle: 'Request and accompany.',
        newOrderBtn: 'Place new order',
        graphTitle: '- Status x Tons (month)',
        graphTitleOrder: 'Orders',
        graphTotal: 'Total (Tons)',
        graphBilled: 'Billed',
      },
      forgotPass: {
        msgEmail: 'Enter your email to reset your password',
        verifyEmail: 'Check email',
        back: 'Back',
        validationEmail: 'Please, type your e-mail',
        msgCode: 'We have sent a code to the email address provided, please enter it in the field below',
        inputCode: 'Code',
        verifyCode: 'Verify codeo',
        backLogin: 'Back to login',
        validationCode: 'Please enter the code',
        msgNewPass: 'Set and confirm your new password',
        inputNewPass: 'New Password',
        inputConfirmNewPass: 'Confirm new password',
        validationNewPass: 'Please enter your password',
        validationConfirmPass: 'Please confirm your new password',
        verifyNewPass: 'Change Password',
        validationMsg: 'Your password must contain the following requirements:',
        validationLength: '- Have at least 8 digits',
        validationNumber: '- Have at least 1 number',
        validationLower: '- Have a uppercase letter',
        validationUpper: '- Have a lowercase letter',
        validationSpecial: '- Have at least 1 special character',
        validationMatch: '- Password and password confirmation same',
        notReceiveCode: 'Did not receive the code',
        msgResend: 'You can request the resend of the code at ',
        seconds: 'seconds',
        erroEmail: 'Email entered not found',
        errorCode: 'Invalid or expired code',
        errorPass: 'Unable to change your password',
        resendEmail: 'Resend email',
        tooltipResend: 'Check your spam or junk folder.'
      },
      firstAccess: {
        msgEmail: 'Enter your email to create your access',
        modalTitle: 'All right!',
        modalBody: 'Your access has been created, now just login.',
        modalBtn: 'Go to login'
      },
      newOrderScreen: {
        rulesTitle: 'Rules for inclusions, changes and cancellations of orders:',
        rule1: 'Same-day additions and changes, please contact Customer Service.',
        rule2: 'Inclusions and changes for the next day must be sent by 11:00 am the day before the upload, Monday through Friday.',
        rule3: 'Requests submitted outside of administrative hours (after 5:00 pm), weekends and holidays, will be reviewed on the next business day.',
        rule4: 'In urgent cases, contact Customer Service.'
      },
      notifications: 'Notifications',
      pagination: "Items per page",
      policies: "Privacy Policies",
      notification: {
        labelTitlePT: "Title PT",
        labelTitleEN: "Title EN",
        labelTitleES: "Title ES",
        labelGroup: "Customer group",
        labelContry: "Country",
        labelActive: "Active",
        labelActions: "Actions",
        labelInitialDate: "Initial date",
        labelFinalDate: "Final date",
        labelBodyPT: 'PT Message',
        labelBodyEN: 'EN message',
        labelBodyES: 'ES Message',
        labelSelect: 'Select',
        errorSave: 'Error saving. Please try again.',
        labelBack: 'To go back',
        labelSave: 'To save',
        insertSucess: 'Notification entered successfully!',
        modifierSucess: 'Notification modified successfully!',
        newNotification: 'New Informative',
        search: 'Search',
        searchFields: 'Search by Title or Group',
        selectAll: 'All',
        active: 'Active',
        inactive: 'Inactive'
      },
      user: {
        labelName: "Name",
        labelActive: "Active",
        labelCreatedAt: 'Created in',
        labelProfile: 'Profile',
        labelActions: 'Actions',
        labelOperator: 'Operator',
        labelOperatorLog: 'Log. Operator',
        labelViewer: 'Viewer',
        labelEditUser: 'Edit User',
        labelUsers: 'Users',
        labelYes: 'YES',
        labelNo: 'NO',
        labelNotRealized: 'Unable to make the change',
        labelUserActive: 'Active user',
        labelSelect: 'Select',
        errorSave: 'Error saving. Try again.',
        labelClient: 'Customers',
        labelBack: 'Back',
        labelSave: 'Save',
        insertSucess: 'User entered successfully!',
        modifierSucess: 'User modified successfully!',
        modifierError: 'Unable to modify user.',
        labelVendor: 'Seller',
        labelInsertEmail: 'Enter a valid email',
        labelCountry: 'Country',
        validateName: 'It is mandatory to provide a name.',
        validateEmail: 'It is mandatory to provide an email.',
        validateProfile: 'It is mandatory to provide a profile.',
        labelCreateUser: 'Create user',
        createdUserSucess: 'User created successfully!',
        msgUserSucess: 'The user will receive a welcome email and the necessary guidance for their first access.',
        createdUserError: 'Unable to create user.',
        brazil: 'Brazil',
        client: 'Customer',
        lastAccess: 'Last Access',
        newUser: 'New User',
        search: 'Search',
        searchFields: 'Search by name or email',
        selectAll: 'All',
        active: 'Active',
        inactive: 'Inactive',
        newUserBack: 'New User for backoffice',
        labelSearchCountry: 'Search by email or country'
      },
      myOrders: {
        labelUniparAnalysis: 'Unipar Analysis',
        labelPendency: 'Pending Customer',
        labelArrived: 'Arrived in the courtyard',
        labelEntry: 'Entry Weight',
        labelInvoiced: 'Invoiced',
        labelOrderNumber: 'Order Number',
        labelDeliveryDate: 'DELIVERY IN',
        labelQty: 'QTY.',
        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'Mar',
        Apr: 'Apr',
        May: 'May',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Aug',
        Sep: 'Sep',
        Oct: 'Oct',
        Nov: 'Nov',
        Dec: 'Dec',
        labelTonPerMonth: 'Tons per month',
        labelChlorine: 'Chlorine'
      },
      customerScreen: {
        labelErrorAccess: 'It was not possible to access this client.',
        labelCode: 'Code',
        labelSearch: 'Search term',
        labelAddress: 'Address',
        labelDocument: 'CNPJ/CUIT',
        labelSearchExample: 'Search by name, code or document',
        search: 'Search',
        searchNotFound: 'No results were found for the search performed!',
        active: 'Active',
        inactive: 'Inactive',
        listUsers: 'List Users',
        accessAs: 'Access As',
        msgEmailAccess: 'Follow the emails that have access to the customer:',
        msgUserNotClient: 'There is no user related to this customer yet',
        prepareAmbient: 'We are preparing the environment, soon you will be directed...',
        accessClient: 'Accessing client',
        afterHourOrder: 'Allow orders after 11 am',
        configQtd: 'Configure quantity'
      },
      editOrder: {
        msgErrorModified: 'We were unable to confirm your changes, please try again.',
        labelOrders: 'Orders',
        labelOrderData: 'Request data',
        labelClient: 'Customer',
        labelReceiver: 'Receiver',
        labelMaterial: 'Material',
        paymentCondition: 'Payment Conditions',
        deposit: 'Deposit',
        orderPortal: 'Portal Order Number',
        labelDelivery: 'Delivery',
        errorDeliveryDatePast: 'Deliveries cannot be scheduled for days past!',
        labelQtyMedia: 'Qty. average',
        labelVehicle: 'Vehicle',
        labelChange: 'Changes',
        labelTransporter: 'Transporter',
        labelNumYourOrder: 'Your order number',
        labelNumYourMaterial: 'Your material code',
        labelOrderItem: 'Order Item',
        labelAddRecuse: 'Add opt-out comment',
        labelAddAlter: 'Add change comment',
        labelSaveChanges: 'Save modifications',
        saveChangesMsgClient: 'Modifications carried out successfully, the customer has been notified to review the changes!',
        saveChangesMsg: 'Modifications carried out successfully!',
        backToChanges: 'Back to requests',
        dateError: 'Invalid selected date!',
        ok: 'I understood',
        labelRefuse: 'Refuse'
      },
      homeScreen: {
        clientCode: 'Customer Code',
        client: 'Customer',
        receiver: 'Receiver',
        createdAt: 'Created At',
        alterAt: 'Altered At',
        labelOrderTitle: 'Order requests',
        labelSearch: 'Search by customer, sku or recipient',
        search: 'Search',
        chemicals: 'Chemicals',
        groupProducts: 'Chemical Group',
        selectAll: 'All',
        editOrder: 'Order Edit'
      },
      modalQuantity: {
        title: 'Quantity per vehicle type',
        columnVehicle: 'VEHICLE TYPE',
        searchPlaceholder: 'Search for incoterm, material and vehicle',
        successMessageAdd: 'Creation completed successfully!',
        successMessageUpdate: 'Change made successfully!',
        errorMessageUpdate: 'An error occurred, please try again!',
        errorMessageAdd: 'Configuration already exists for the client!',
        btnBack: 'Back',
        btnSave: 'Save',
        btnAdd: 'Add',
        validation: 'The minimum quantity cannot be greater than the maximum'
      },
      widgetColumnReport: {
        view: 'Viewing'
      },
      customersSurveyConfiguration: {
        menu: 'NPS CSAT Feedbacks',
        monthsActive: 'Months Active',
        displayQuantity: 'Display Quantity',
        save: 'Save',
        close: 'Close',
        getErrorMessage: 'Error getting Configuration data',
        saveErrorMessage: 'Error saving Configuration data',
        saveSuccessMessage: 'Modifications carried out successfully!',
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December'
      },
      customersSurveyReportPage: {
        exportXLS: 'Export XLS',
        avgMonth: 'Average by month',
        customerName: 'Customer',
        createdAt: 'Created At',
        avg: 'Period average',
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      },
      holidaysConfiguration: {
        menu: 'Holidays',
        searchFields: 'Search by country, type, description, year, date or factory'
      },
      callCenter: {
        menu: 'Contact Us',
        newTicket: 'New Ticket',
        viewTicket: 'View Ticket',
        sector: 'Sector',
        number: 'Service Number',
        ticketLevelAll: 'All',
        pending: 'Pending Unipar',
        served: 'Served',
        finished: 'Finished',
        newPageTitle: 'Send request',
        viewHistoryPageTitle: 'Service history',
        viewDetailsPageTitle: 'Request Details',
        labelSubject: 'Subject',
        labelSubjectSelect: 'Select subject',
        labelPhone: 'Phone Number',
        labelPhonePlaceholder: 'Input phone number',
        labelDescription: 'Message',
        labelDescriptionPlaceholder: 'Input text',
        labelIsLate: 'Is Late',
        attachmentsCustomer: 'Attachments Customer',
        attachmentsUnipar: 'Attachments Unipar',
        userMessage: 'Message sent',
        uniparReply: 'Unipar Reply',
        servedWarningMessage: 'If there is no new interaction for this ticket in {{daysToFinishTicket}} day, this will be finished.',
        successMessage: 'Message sent successfully',
        errorMessage: 'Error sending message',
        servedConfirmMessage: 'Confirm ticket serve?',
        servedMessage: 'Ticket served',
        addReply: 'Add reply',
        serveTicket: 'Serve ticket',
        errorServedMessage: 'Error serving ticket',
        errorChangeSectorMessage: 'Error changing sector',
        labelEmail: 'Email',
        labelName: 'Name',
        labelCreatedBy: 'Created by',
      },
      callCenterReportPage: {
        resolved: 'Resolved',
        bySector: 'By sector',
        byTicketLevel: 'By subject'
      },
      bankingAccount: 'Banking Account',
      banking: {
        bank: 'Bank',
        agency: 'Agency/CBU',
        account: 'Account',
        pixKey: 'PIX Key',
        pixKeyType: 'PIX Key Type',
        companyName: 'Company',
        companyDocument: 'Document',
        country: 'Country',
        labelActions: 'Actions',
        new: 'New Banking Account',
        edit: 'Edit Banking Account',
        active: 'Active',
        inactive: 'Inactive',
        search: 'Search',
        searchBy: 'Search by Bank, Agency, Account or PIX Key',
        phone: 'Telephone',
        random: 'Random key',
        fieldsErrorMessage: 'Please fill in all required fields marked with *.',
        emailPixError: 'Invalid email provided in the PIX key.',
        cnpjPixError: 'Invalid CNPJ informed in the PIX key.',
        documentError: 'Company document is invalid.'
      },
      success: 'Saved successfully.',
      successTitle: 'Success',
      error: 'An error occurred while saving data.',
    },
  },
  pt: {
    translation: {
      welcome: 'Back-Office Unipar',
      customer: 'Cliente',
      myOrder: 'Todos Pedidos',
      financial: 'Cotação',
      logout: 'Sair',
      drakMode: 'Modo Escuro',
      home: 'Solicitações de pedido',
      reports: 'Relatórios',
      config: 'Configurações',
      users: 'Usuários',
      usersBack: 'Usuários BackOffice',
      customers: 'Clientes',
      applyFilter: 'Aplicar filtros',
      filterData: 'Filtrar dados',
      products: 'Produtos',
      period: 'Período',
      select: 'Selecione',
      totalOrders: 'Total de pedidos',
      cancelledOrders: 'Pedidos cancelados',
      updatedOrders: 'Pedidos alterados',
      viewingData: 'Visualizando dados',
      exportOrders: 'Exportar pedidos',
      exportCustomers: 'Exportar clientes',
      byProducts: 'Por produtos',
      origin: 'Origem',
      orders: 'Pedidos',
      customersSurveyReport: 'Feedbacks NPS CSAT',
      searchNotFound: 'Não foram encontrados resultados para a busca realizada!',
      configurations: 'Configurações',
      office: 'Escritório',
      factory: 'Fábrica',
      new: 'Novo',
      edit: 'Editar',
      remove: 'Remover',
      actions: 'Ações',
      interval: 'Período',
      intervalAll: 'Todos',
      createdAt: 'Data Criação',
      search: 'Buscar',
      noResults: 'Não foram encontrados resultados',
      attachFile: 'Anexar arquivo',
      addFile: 'Incluir anexo',
      permittedFiles: 'Arquivos permitidos: ',
      attachments: 'Anexos',
      fileRemoveModalTitle: 'Deseja remover o anexo?',
      close: 'Fechar',
      confirm: 'Confirmar',
      description: 'Descrição',
      country: 'País',
      type: 'Tipo',
      year: 'Ano',
      dates: 'Datas',
      removeConfirmation: 'Confirma a exclusão deste registro?',
      yes: 'Sim',
      no: 'Não',
      errorSave: 'Erro ao salvar. Tente novamente.',
      successSave: 'Registro atualizado com sucesso!',
      validateType: 'É obrigatório informar um tipo.',
      validateCountry: 'É obrigatório informar um país.',
      validateYear: 'É obrigatório informar um ano.',
      validateFactory: 'É obrigatório informar uma fábrica.',
      validateDescription: 'É obrigatório informar uma descrição.',
      validateDates: 'É obrigatório informar uma data ou datas.',
      save: 'Salvar',
      back: 'Voltar',
      group: 'Grupo',
      all: 'Todos',
      send: 'Enviar',
      fieldErrorMandatoryMessage: 'Preenchimento é obrigatório',
      errorSearchMessage: 'Erro obtendo dados',
      errorRemoveMessage: 'Erro removendo dados',
      exportXLS: 'Exportar XLS',
      report: {
        totalOrders: 'Total ped.',
        orders: 'pedidos',
        portal: 'Portal'
      },
      reportOrigin: {
        sap: 'SAP',
        general: 'Geral',
        web: 'Portal'
      },
      reportMaterialType: {
        pvc: 'PVC',
        chemical: 'Químicos'
      },
      periodAlert: {
        periodRequired: 'Informe o período.',
        periodNinetyDays: 'Período máximo deve ser de 90 dias.',
        invalidDate: 'Data inválida.'
      },
      links: 'Links úteis',
      link: {
        newLink: 'Novo Link',
        editLink: 'Editar Link',
        searchFields: 'Buscar por título, descrição ou link',
        search: 'Busca',
        selectAll: 'Todos',
        active: 'Ativo',
        inactive: 'Inativo',
        labelCreateLink: 'Criar link',
        labelLinks: 'Links',
        labelTitle: 'Título',
        labelDescription: 'Texto',
        labelTitleEN: 'Título Inglês',
        labelTitlePT: 'Título Português',
        labelTitleES: 'Título Espanhol',
        labelDescriptionEN: 'Texto Inglês',
        labelDescriptionPT: 'Texto Português',
        labelDescriptionES: 'Texto Espanhol',
        labelLink: 'Link',
        selectStatusActive: 'Ativo',
        selectStatusInactive: 'Inativo',
        labelSelect: 'Selecione',
        labelStatus: 'Status',
        labelCountry: 'País',
        errorTitle: 'É obrigatório informar todos os títulos.',
        errorDescription: 'É obrigatório informar todas as descrições.',
        errorLink: 'É obrigatório informar o link.',
        errorCountry: 'Selecione um país.',
        createdTitle: 'Link criado com sucesso!',
        createdMsg: 'O link está visível no portal do cliente.',
        createError: 'An error has occurred',
        editedTitle: 'Link editado com sucesso!',
      },
      notificationMenu: 'Informativos',
      login: {
        title: 'Back-Office Unipar',
        subtitle: 'Nosso propósito é ser confiável em todas as nossas relações',
        login: 'Entrar',
        forgotPass: 'Esqueci minha senha',
        register: 'Primeiro acesso',
        pass: 'Senha',
        passValidation: 'Por favor digite sua senha',
        emailValidation: 'Por favor digite seu email',
        robotBtn: 'Não sou um robô',
        notauthentication: 'Não autenticado, aguarde...',
        authentication: 'Autenticando...'
      },
      homeWidgets: {
        newOrderTitle: 'Faça um novo pedido',
        newOrderSubTitle: 'Solicite e acompanhe.',
        newOrderBtn: 'Fazer novo pedido',
        graphTitle: '- Status x Toneladas (mês)',
        graphTitleOrder: 'Pedidos',
        graphTotal: 'Total (toneladas)',
        graphBilled: 'Faturadas',
      },
      forgotPass: {
        msgEmail: 'Digite seu email para resetar sua senha',
        verifyEmail: 'Verificar email',
        back: 'Voltar',
        validationEmail: 'Por favor digite seu email',
        msgCode: 'Enviamos um código para o email informado, por favor o insira no campo abaixo',
        inputCode: 'Código',
        verifyCode: 'Verificar código',
        backLogin: 'Voltar para o login',
        validationCode: 'Por favor digite o código',
        msgNewPass: 'Defina e confirme sua nova senha',
        inputNewPass: 'Nova senha',
        inputConfirmNewPass: 'Confirmar nova senha',
        validationNewPass: 'Por favor digite sua senha',
        validationConfirmPass: 'Por favor confirme sua nova senha',
        verifyNewPass: 'Alterar senha',
        validationMsg: 'A sua senha deve conter os seguintes requisitos:',
        validationLength: '- Ter ao menos 8 dígitos',
        validationNumber: '- Ter ao menos 1 número',
        validationLower: '- Ter uma letra maiúscula',
        validationUpper: '- Ter uma letra minúscula',
        validationSpecial: '- Ter ao menos 1 carácter especial',
        validationMatch: '- Senha e confirmação de senha iguais',
        notReceiveCode: 'Não recebeu o código',
        msgResend: 'Você poderá solicitar o reenvio do código em ',
        seconds: 'segundos',
        erroEmail: 'Email digitado não encontrado',
        errorCode: 'Código inválido ou expirado',
        errorPass: 'Não foi possivel alterar sua senha',
        resendEmail: 'Reenviar email',
        tooltipResend: 'Verifique em sua caixa de spam ou lixo eletrônico.'
      },
      firstAccess: {
        msgEmail: 'Digite seu email para criar o seu acesso',
        modalTitle: 'Tudo certo!',
        modalBody: 'Seu acesso foi criado, agora é só realizar seu login.',
        modalBtn: 'Ir para login'
      },
      newOrderScreen: {
        rulesTitle: 'Regras para inclusões, alterações e cancelamentos de pedidos:',
        rule1: 'Inclusões e alterações para o mesmo dia, favor entrar em contato com o Atendimento ao Cliente.',
        rule2: 'Inclusões e alterações para o dia seguinte, devem ser enviadas até as 11:00 do dia anterior ao carregamento, de segunda à sexta.',
        rule3: 'Solicitações enviadas fora do horário administrativo (após as 17:00), finais de semana e feriados, serão analisadas no próximo dia útil.',
        rule4: 'Em caso de urgência, contatar o Atendimento ao Cliente.'
      },
      notifications: 'Notificações',
      pagination: "Itens por página",
      policies: "Políticas de Privacidade",
      notification: {
        labelTitlePT: "Título PT",
        labelTitleEN: "Título EN",
        labelTitleES: "Título ES",
        labelGroup: "Grupo de cliente",
        labelContry: "País",
        labelActive: "Ativo",
        labelActions: "Ações",
        labelInitialDate: "Data inicial",
        labelFinalDate: "Data final",
        labelBodyPT: 'Mensagem PT',
        labelBodyEN: 'Mensagem EN',
        labelBodyES: 'Mensagem ES',
        labelSelect: 'Selecione',
        errorSave: 'Erro ao salvar. Por favor tente novamente.',
        labelBack: 'Voltar',
        labelSave: 'Salvar',
        insertSucess: 'Notificação inserida com sucesso!',
        modifierSucess: 'Notificação modificada com sucesso!',
        newNotification: 'Novo Informativo',
        search: 'Busca',
        searchFields: 'Buscar por Título ou Grupo',
        selectAll: 'Todos',
        active: 'Ativo',
        inactive: 'Inativo'
      },
      user: {
        labelName: "Nome",
        labelActive: "Ativo",
        labelCreatedAt: 'Criado EM',
        labelProfile: 'Perfil',
        labelActions: 'Ações',
        labelOperator: 'Operador',
        labelOperatorLog: 'Operador Log.',
        labelViewer: 'Visualizador',
        labelEditUser: 'Editar usuário',
        labelUsers: 'Usuários',
        labelYes: 'SIM',
        labelNo: 'NÃO',
        labelNotRealized: 'Não foi possivel realizar a alteração',
        labelUserActive: 'Usuário ativo',
        labelSelect: 'Selecione',
        errorSave: 'Erro ao salvar. Tente novamente.',
        labelClient: 'Clientes',
        labelBack: 'Voltar',
        labelSave: 'Salvar',
        insertSucess: 'Usuário inserido com sucesso!',
        modifierSucess: 'Usuário modificado com sucesso!',
        modifierError: 'Não foi possível modificar o usuário.',
        labelVendor: 'Vendedor',
        labelInsertEmail: 'Insira um email válido',
        labelCountry: 'País',
        validateName: 'É obrigatório informar um nome.',
        validateEmail: 'É obrigatório informar um email.',
        validateProfile: 'É obrigatório informar um perfil',
        labelCreateUser: 'Criar usuário',
        createdUserSucess: 'Usuário criado com sucesso!',
        msgUserSucess: 'O usuário irá receber um email de boas vindas e a orientação necessária para o seu primeiro acesso.',
        createdUserError: 'Não foi possível criar o usuário.',
        brazil: 'Brasil',
        client: 'Cliente',
        lastAccess: 'Ultimo acesso',
        newUser: 'Novo Usuário',
        search: 'Busca',
        searchFields: 'Buscar por nome ou email',
        selectAll: 'Todos',
        active: 'Ativo',
        inactive: 'Inativo',
        newUserBack: 'Novo Usuário para backoffice',
        labelSearchCountry: 'Buscar por email ou país'
      },
      myOrders: {
        labelUniparAnalysis: 'Análise Unipar',
        labelPendency: 'Pendente Cliente',
        labelArrived: 'Chegou no pátio',
        labelEntry: 'Peso Entrada',
        labelInvoiced: 'Faturados',
        labelOrderNumber: 'Número Pedido',
        labelDeliveryDate: 'ENTREGA EM',
        labelQty: 'QTDE.',
        Jan: 'Jan',
        Feb: 'Fev',
        Mar: 'Mar',
        Apr: 'Abr',
        May: 'Mai',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Ago',
        Sep: 'Set',
        Oct: 'Out',
        Nov: 'Nov',
        Dec: 'Dez',
        labelTonPerMonth: 'Toneladas por mês',
        labelChlorine: 'Cloro'
      },
      customerScreen: {
        labelErrorAccess: 'Não foi possivel realizar o acesso com esse cliente.',
        labelCode: 'Código',
        labelSearch: 'Termo de busca',
        labelAddress: 'Endereço',
        labelDocument: 'CNPJ/CUIT',
        labelSearchExample: 'Buscar por nome, código ou cnpj',
        search: 'Buscar',
        searchNotFound: 'Não foram encontrados resultados para a busca realizada!',
        active: 'Ativo',
        inactive: 'Inativo',
        listUsers: 'Lista de Usuários',
        accessAs: 'Acessar Como',
        msgEmailAccess: 'Segue os emails que possuem acesso ao cliente:',
        msgUserNotClient: 'Ainda não tem usuário relacionado a esse cliente',
        prepareAmbient: 'Estamos preparando o ambiente, logo você será direcionado...',
        accessClient: 'Acessando cliente',
        afterHourOrder: 'Permitir pedidos após 11 horas',
        configQtd: 'Configurar quantidade'
      },
      editOrder: {
        msgErrorModified: 'Não foi possivel confirmar suas modificações, por favor tente novamente.',
        labelOrders: 'Pedidos',
        labelOrderData: 'Dados da solicitação',
        labelClient: 'Cliente',
        labelReceiver: 'Recebedor',
        labelMaterial: 'Material',
        paymentCondition: 'Condição de pgto.',
        deposit: 'Depósito',
        orderPortal: 'Num. Pedido Portal',
        labelDelivery: 'Entrega',
        errorDeliveryDatePast: 'Não pode ser programado entregas para dias passados!',
        labelQtyMedia: 'Qtde. média',
        labelVehicle: 'Veículo',
        labelChange: 'Alterações',
        labelTransporter: 'Transportador',
        labelNumYourOrder: 'Nº do seu pedido',
        labelNumYourMaterial: 'Nº do material',
        labelOrderItem: 'Item do pedido',
        labelAddRecuse: 'Adicionar comentário de recusa',
        labelAddAlter: 'Adicionar comentário de alteração',
        labelSaveChanges: 'Salvar modificações',
        saveChangesMsgClient: 'Modificações realizadas com sucesso, o cliente foi notificado para revisar as alterações!',
        saveChangesMsg: 'Modificações realizadas com sucesso!',
        backToChanges: 'Voltar para solicitações',
        dateError: 'Data selecionada inválida!',
        ok: 'Entendi',
        labelRefuse: 'Recusar'
      },
      homeScreen: {
        clientCode: 'Cod. Cliente',
        client: 'Cliente',
        receiver: 'Recebedor',
        createdAt: 'Criada Em',
        alterAt: 'Alterada Em',
        labelOrderTitle: 'Solicitações de pedido',
        labelSearch: 'Buscar por cliente, sku ou recebedor',
        search: 'Buscar',
        chemicals: 'Químicos',
        groupProducts: 'Grupo de Produtos',
        selectAll: 'Todos',
        editOrder: 'Editar Pedidos'
      },
      modalQuantity: {
        title: 'Quantidade por tipo de veículo',
        columnVehicle: 'TIPO DE VEÍCULO',
        searchPlaceholder: 'Buscar por incoterm, material e veículo',
        successMessageAdd: 'Criação realizada com sucesso!',
        successMessageUpdate: 'Alteração realizada com sucesso!',
        errorMessageUpdate: 'Ocorreu um erro tente novamente por favor!',
        errorMessageAdd: 'Configuração já existe para o cliente!',
        btnBack: 'Voltar',
        btnSave: 'Salvar',
        btnAdd: 'Adicionar',
        validation: 'A quantidade mínima não pode ser maior que a máxima'
      },
      widgetColumnReport: {
        view: 'Visualizando'
      },
      customersSurveyConfiguration: {
        menu: 'Feedbacks NPS CSAT',
        monthsActive: 'Meses Ativos',
        displayQuantity: 'Quantidade de Exibições',
        save: 'Salvar',
        close: 'Fechar',
        getErrorMessage: 'Erro ao obter dados de Configuração',
        saveErrorMessage: 'Erro ao salvar dados de Configuração',
        saveSuccessMessage: 'Modificações realizadas com sucesso!',
        january: 'Janeiro',
        february: 'Fevereiro',
        march: 'Março',
        april: 'Abril',
        may: 'Maio',
        june: 'Junho',
        july: 'Julho',
        august: 'Agosto',
        september: 'Setembro',
        october: 'Outubro',
        november: 'Novembro',
        december: 'Dezembro'
      },
      customersSurveyReportPage: {
        exportXLS: 'Exportar XLS',
        avgMonth: 'Média por mês',
        avg: 'Média do período',
        customerName: 'Cliente',
        createdAt: 'Criado Em',
        jan: 'Jan',
        feb: 'Fev',
        mar: 'Mar',
        apr: 'Abr',
        may: 'Mai',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Ago',
        sep: 'Set',
        oct: 'Out',
        nov: 'Nov',
        dec: 'Dez'
      },
      holidaysConfiguration: {
        menu: 'Feriados',
        searchFields: 'Buscar por país, tipo, descrição, ano, data ou fábrica'
      },
      callCenter: {
        menu: 'Fale Conosco',
        newTicket: 'Novo Atendimento',
        viewTicket: 'Minha Solicitação',
        sector: 'Área',
        number: 'Nº Solicitação',
        ticketLevelAll: 'Todos',
        pending: 'Pendente Unipar',
        served: 'Atendido',
        finished: 'Finalizado',
        newPageTitle: 'Envia sua solicitação',
        viewHistoryPageTitle: 'Histórico de atendimento',
        viewDetailsPageTitle: 'Detalhes da solicitação',
        labelSubject: 'Assunto',
        labelSubjectSelect: 'Selecione o assunto',
        labelPhone: 'Telefone',
        labelPhonePlaceholder: 'Insira o número de contato',
        labelDescription: 'Mensagem',
        labelDescriptionPlaceholder: 'Insira o texto',
        labelIsLate: 'Em Atraso',
        attachmentsCustomer: 'Anexos Cliente',
        attachmentsUnipar: 'Anexos Unipar',
        userMessage: 'Mensagem enviada',
        uniparReply: 'Resposta Unipar',
        servedWarningMessage: 'Se não houver uma nova interação nesse atendimento em {{daysToFinishTicket}} dia, ele será finalizado.',
        successMessage: 'Mensagem enviada com sucesso',
        errorMessage: 'Erro ao enviar mensagem',
        servedConfirmMessage: 'Confirma a resolução do atendimento?',
        servedMessage: 'Atendimento resolvido',
        addReply: 'Adicionar resposta',
        serveTicket: 'Resolver atendimento',
        errorServedMessage: 'Erro resolvendo atendimento',
        errorChangeSectorMessage: 'Erro alterando área',
        labelEmail: 'Email',
        labelName: 'Nome',
        labelCreatedBy: 'Aberto por',
      },
      callCenterReportPage: {
        resolved: 'Finalizados',
        bySector: 'Por área',
        byTicketLevel: 'Por assunto'
      },
      bankingAccount: 'Dados Bancários',
      banking: {
        bank: 'Banco',
        agency: 'Agência/CBU',
        account: 'Conta',
        pixKey: 'Chave PIX',
        pixKeyType: 'Tipo Chave PIX',
        companyName: 'Empresa',
        companyDocument: 'Documento',
        country: 'País',
        labelActions: 'Ações',
        new: 'Nova Conta Bancária',
        edit: 'Editar Conta Bancária',
        active: 'Ativo',
        inactive: 'Inativo',
        search: 'Busca',
        searchBy: 'Buscar por Banco, Agência, Conta ou Chave PIX',
        phone: 'Telefone',
        random: 'Chave Aleatória',
        fieldsErrorMessage: 'Por favor informe todos os campos obrigatórios identificados com o *.',
        emailPixError: 'Email inválido informado na chave PIX.',
        cnpjPixError: 'CNPJ inválido informado na chave PIX.',
        documentError: 'Documento da empresa é inválido.'

      },
      success: 'Salvo com sucesso.',
      successTitle: 'Sucesso',
      error: 'Ocorreu um erro ao salvar os dados.',
    }
  },
  es: {
    translation: {
      welcome: 'Back-Office Unipar',
      customer: 'Cliente',
      myOrder: 'Todos pedidos',
      financial: 'Precio',
      logout: 'Sair',
      drakMode: 'Modo Oscuro',
      home: 'Intenciones de pedido',
      reports: 'Informes',
      config: 'Configuraciones',
      users: 'Usuarios',
      usersBack: 'Usuarios BackOffice',
      customers: 'Clientes',
      period: 'Período',
      origin: 'Origen',
      select: 'Seleccionar',
      products: 'Productos',
      applyFilter: 'Aplicar filtros',
      filterData: 'Filtrar datos',
      totalOrders: 'Pedidos totales',
      cancelledOrders: 'Pedidos cancelados',
      updatedOrders: 'Pedidos modificados',
      viewingData: 'Mostrando datos',
      exportOrders: 'Descargar pedidos',
      exportCustomers: 'Descargar clientes',
      byProducts: 'Por productos',
      orders: 'Pedidos',
      customersSurveyReport: 'NPS CSAT Feedbacks',
      searchNotFound: '¡No se encontraron resultados para la búsqueda realizada!',
      configurations: 'Configuraciones',
      office: 'Escritorio',
      factory: 'Fábrica',
      new: 'Nuevo',
      edit: 'Editar',
      remove: 'Eliminar',
      actions: 'Acciones',
      interval: 'Período',
      intervalAll: 'Todos',
      createdAt: 'Fecha de Creación',
      search: 'Buscar',
      noResults: 'No se encontraron resultados',
      attachFile: 'Adjuntar archivo',
      permittedFiles: 'Archivos permitidos: ',
      attachments: 'Archivos adjuntos',
      addFile: 'Incluir archivo adjunto',
      fileRemoveModalTitle: '¿Quieres eliminar el archivo adjunto?',
      close: 'Cerrar',
      confirm: 'Confirmar',
      description: 'Descripción',
      country: 'País',
      type: 'Tipo',
      year: 'Año',
      dates: 'Fechas',
      removeConfirmation: '¿Confirma la eliminación de este registro?',
      yes: 'Sí',
      no: 'No',
      errorSave: 'Error al guardar. Inténtalo de nuevo.',
      successSave: '¡Registro modificado exitosamente!',
      validateType: 'Es obligatorio proporcionar un tipo.',
      validateCountry: 'Es obligatorio proporcionar un país.',
      validateYear: 'Es obligatorio proporcionar un año.',
      validateFactory: 'Es obligatorio proporcionar una fábrica.',
      validateDescription: 'Es obligatorio proporcionar una descripcion.',
      validateDates: 'Es obligatorio proporcionar una fecha o fechas.',
      save: 'Registrar',
      back: 'Volver',
      group: 'Grupo',
      all: 'Todos',
      send: 'Mandar',
      fieldErrorMandatoryMessage: 'Valor es obligatorio',
      errorSearchMessage: 'Error al obtener datos',
      errorRemoveMessage: 'Error al eliminar datos',
      exportXLS: 'Exportar XLS',
      report: {
        totalOrders: 'Ped. totales',
        orders: 'pedidos',
        portal: 'Portal'
      },
      reportOrigin: {
        sap: 'SAP',
        general: 'Generales',
        web: 'Web'
      },
      reportMaterialType: {
        pvc: 'PVC',
        chemical: 'Quimicos'
      },
      periodAlert: {
        periodRequired: 'Introduzca el período.',
        periodNinetyDays: 'El plazo máximo debe ser de 90 días.',
        invalidDate: 'Fecha invalida.'
      },
      links: 'Enlaces útiles',
      link: {
        newLink: 'Nuevo enlace',
        editLink: 'Editar Enlace',
        searchFields: 'Buscar por título, descripción o enlace',
        search: 'Buscar',
        selectAll: 'Todo',
        active: 'Activo',
        inactive: 'Inactivo',
        labelCreateLink: 'Crear enlace',
        labelLinks: 'Enlaces',
        labelTitle: 'Título',
        labelDescription: 'Texto',
        labelTitleEN: 'Título en Inglés',
        labelTitlePT: 'Título Portugués',
        labelTitleES: 'Título Español',
        labelDescriptionEN: 'Texto Inglés',
        labelDescriptionPT: 'Texto Portugués',
        labelDescriptionES: 'Texto en español',
        labelLink: 'Enlace',
        selectStatusActive: 'Activo',
        selectStatusInactive: 'Inactivo',
        labelSelect: 'Seleccionar',
        labelStatus: 'Estado',
        labelCountry: 'País',
        errorTitle: 'Es obligatorio informar todos los títulos.',
        errorDescription: 'Es obligatorio proporcionar todas las descripciones.',
        errorLink: 'Es obligatorio proporcionar el enlace.',
        errorCountry: 'Seleccione un país.',
        createdTitle: '¡Enlace creado exitosamente!',
        createdMsg: 'El enlace es visible en el portal del cliente.',
        createError: 'Ocurrio un error',
        editedTitle: 'Enlace editado exitosamente!',
      },
      notificationMenu: 'Informativos',
      login: {
        title: 'Back-Office Unipar',
        subtitle: 'Nuestro propósito es ser confiables en todas nuestras relaciones',
        login: 'Entrar',
        forgotPass: 'Olvide mi contraseña',
        register: 'Primer acceso',
        pass: 'Contraseña',
        passValidation: 'Por favor, escriba su contraseña',
        emailValidation: 'Por favor, escriba su email',
        robotBtn: 'No soy un robot',
        notauthentication: 'No autenticado, por favor espere...',
        authentication: 'Autenticación...'
      },
      homeWidgets: {
        newOrderTitle: 'Hacer un nuevo pedido',
        newOrderSubTitle: 'Solicitar y acompañar.',
        newOrderBtn: 'Hacer nuevo pedido',
        graphTitle: '- Status x Toneladas (mes)',
        graphTitleOrder: 'Peticiones',
        graphTotal: 'Total (toneladas)',
        graphBilled: 'Facturado',
      },
      forgotPass: {
        msgEmail: 'Ingrese su correo electrónico para restablecer su contraseña',
        verifyEmail: 'Revisar correo electrónico',
        back: 'Volver',
        validationEmail: 'Por favor, escriba su correo electrónico',
        msgCode: 'Hemos enviado un código a correo electrónico proporcionada, ingréselo en el campo a continuación',
        inputCode: 'Código',
        verifyCode: 'Verificar código',
        backLogin: 'Volver para login',
        validationCode: 'Por favor ingrese el código',
        msgNewPass: 'Establece y confirma tu nueva contraseña',
        inputNewPass: 'Nueva contraseña',
        inputConfirmNewPass: 'Confirmar nueva contraseña',
        validationNewPass: 'Por favor, introduzca su contraseña',
        validationConfirmPass: 'Por favor confirme su nueva contraseña',
        verifyNewPass: 'Cambiar contraseña',
        validationMsg: 'Su contraseña debe contener los siguientes requisitos:',
        validationLength: '- Tener al menos 8 dígitos',
        validationNumber: '- Tener al menos 1 número',
        validationLower: '- Tener una letra mayúscula',
        validationUpper: '- Tener una letra minúscula',
        validationSpecial: '- Tener al menos 1 carácter especial',
        validationMatch: '- Contraseña y confirmación de contraseña igual',
        notReceiveCode: '¿No recibiste el código',
        msgResend: 'Puedes solicitar el reenvío del código en ',
        seconds: 'segundos',
        erroEmail: 'Correo electrónico ingresado no encontrado',
        errorCode: 'Código no válido o caducado',
        errorPass: 'No se puede cambiar su contraseña',
        resendEmail: 'Reenviar email',
        tooltipResend: 'Revisa tu carpeta de spam o basura.'
      },
      firstAccess: {
        msgEmail: 'Introduce tu email para crear tu acceso',
        modalTitle: '¡Muy bien!',
        modalBody: 'Su acceso ha sido creado, ahora solo inicie sesión.',
        modalBtn: 'Ir a iniciar sesión'
      },
      newOrderScreen: {
        rulesTitle: 'Reglas para inclusiones, cambios y cancelaciones de pedidos:',
        rule1: 'Adiciones y cambios en el mismo día, comuníquese con Servicio al Cliente.',
        rule2: 'Las inclusiones y cambios para el día siguiente deben enviarse antes de las 11:00 am del día anterior a la carga, de lunes a viernes.',
        rule3: 'Las solicitudes enviadas fuera del horario administrativo (después de las 5:00 pm), fines de semana y feriados, serán revisadas el siguiente día hábil.',
        rule4: 'En casos urgentes, póngase en contacto con el Servicio de Atención al Cliente.'
      },
      notifications: 'Notificaciones',
      pagination: "Artículos por página",
      policies: "Políticas de privacidad",
      notification: {
        labelTitlePT: "Título PT",
        labelTitleEN: "Título EN",
        labelTitleES: "Título ES",
        labelGroup: "Grupo de clientes",
        labelContry: "País",
        labelActive: "Activo",
        labelActions: "Accions",
        labelInitialDate: "Fecha inicio",
        labelFinalDate: "Fecha final",
        labelBodyPT: 'Mensaje PT',
        labelBodyEN: 'Mensaje EN',
        labelBodyES: 'Mensaje ES',
        labelSelect: 'Seleccionar',
        errorSave: 'Error al guardar. Inténtalo de nuevo.',
        labelBack: 'Volver',
        labelSave: 'Salvar',
        insertSucess: '¡Notificación ingresada exitosamente!',
        modifierSucess: '¡Notificación modificada exitosamente!',
        newNotification: 'Nuevo boletín',
        search: 'Buscar',
        searchFields: 'Buscar por título o grupo',
        selectAll: 'Todo',
        active: 'Activo',
        inactive: 'Inactivo'
      },
      user: {
        labelName: "Nombre",
        labelActive: "Activo",
        labelCreatedAt: 'Creado en',
        labelProfile: 'Perfil',
        labelActions: 'Ações',
        labelOperator: 'Operador',
        labelOperatorLog: 'Operador Log.',
        labelViewer: 'Espectador',
        labelEditUser: 'Editar usuario',
        labelUsers: 'Usuarios',
        labelYes: 'SÍ',
        labelNo: 'NO',
        labelNotRealized: 'No se puede hacer el cambio',
        labelUserActive: 'Usuario activo',
        labelSelect: 'Seleccionar',
        errorSave: 'Error al guardar. Inténtalo de nuevo.',
        labelClient: 'Clientes',
        labelBack: 'Volver',
        labelSave: 'Registrar',
        insertSucess: '¡El usuario ingresó exitosamente!',
        modifierSucess: '¡Usuario modificado exitosamente!',
        modifierError: 'No se puede modificar el usuario.',
        labelVendor: 'Vendedor',
        labelInsertEmail: 'Introduzca un correo electrónico válido',
        labelCountry: 'País',
        validateName: 'Es obligatorio proporcionar un nombre.',
        validateEmail: 'Es obligatorio proporcionar un email.',
        validateProfile: 'Es obligatorio proporcionar un perfil.',
        labelCreateUser: 'Crear usuario',
        createdUserSucess: '¡Usuario creado exitosamente!',
        msgUserSucess: 'El usuario recibirá un correo electrónico de bienvenida y la orientación necesaria para su primer acceso.',
        createdUserError: 'No se puede crear usuario.',
        brazil: 'Brasil',
        client: 'Cliente',
        lastAccess: 'Último acceso',
        newUser: 'Nuevo Usuario',
        search: 'Buscar',
        searchFields: 'Buscar por nombre o correo electrónico',
        selectAll: 'Todo',
        active: 'Activo',
        inactive: 'Inactivo',
        newUserBack: 'Nuevo usuario para backoffice',
        labelSearchCountry: 'Buscar por correo electrónico o país'
      },
      myOrders: {
        labelUniparAnalysis: 'Análisis Unipar',
        labelPendency: 'Cliente en espera',
        labelArrived: 'Llegó al patio',
        labelEntry: 'Peso de entrada',
        labelInvoiced: 'Facturado',
        labelOrderNumber: 'Número de orden',
        labelDeliveryDate: 'ENTREGA EN',
        labelQty: 'QTDE.',
        Jan: 'Jan',
        Feb: 'Fev',
        Mar: 'Mar',
        Apr: 'Abr',
        May: 'Mai',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Ago',
        Sep: 'Set',
        Oct: 'Out',
        Nov: 'Nov',
        Dec: 'Dez',
        labelTonPerMonth: 'Toneladas por mes',
        labelChlorine: 'Cloro'
      },
      customerScreen: {
        labelErrorAccess: 'No fue posible acceder a este cliente.',
        labelCode: 'Código',
        labelSearch: 'Término de búsqueda',
        labelAddress: 'Dirección',
        labelDocument: 'CNPJ/CUIT',
        labelSearchExample: 'Buscar por nombre, código o documento',
        search: 'Buscar',
        searchNotFound: '¡No se encontraron resultados para la búsqueda realizada!',
        active: 'Activo',
        inactive: 'Inactivo',
        listUsers: 'Lista de usuarios',
        accessAs: 'Acceder Cómo',
        msgEmailAccess: 'A continuación se detallan los correos electrónicos a los que tiene acceso el cliente:',
        msgUserNotClient: 'Aún no hay ningún usuario relacionado con este cliente.',
        prepareAmbient: 'Estamos preparando el ambiente, pronto os dirigirán...',
        accessClient: 'Accediendo al cliente',
        afterHourOrder: 'Permitir pedidos después de las 11 a.m.',
        configQtd: 'Configurar cantidad'
      },
      editOrder: {
        msgErrorModified: 'No pudimos confirmar sus cambios, inténtelo nuevamente.',
        labelOrders: 'Pedidos',
        labelOrderData: 'Solicitar datos',
        labelClient: 'Cliente',
        labelReceiver: 'Receptor',
        labelMaterial: 'Material',
        paymentCondition: 'Condiciones de pago.',
        deposit: 'Deposito',
        orderPortal: 'Número de pedido del portal',
        labelDelivery: 'Entrega',
        errorDeliveryDatePast: '¡No se pueden programar entregas para días pasados!',
        labelQtyMedia: 'Cant. promedio',
        labelVehicle: 'Vehículo',
        labelChange: 'Cambios',
        labelTransporter: 'Transportador',
        labelNumYourOrder: 'Su número de orden',
        labelNumYourMaterial: 'Num de Material.',
        labelOrderItem: 'Articulo ordenado',
        labelAddRecuse: 'Agregar comentario de exclusión voluntaria',
        labelAddAlter: 'Agregar comentario de cambio',
        labelSaveChanges: 'Guardar modificaciones',
        saveChangesMsgClient: 'Modificaciones realizadas con éxito, ¡el cliente ha sido notificado para revisar los cambios!',
        saveChangesMsg: '¡Modificaciones realizadas con éxito!',
        backToChanges: 'Volver a solicitudes',
        dateError: '¡Fecha seleccionada no válida!',
        ok: 'Entendí',
        labelRefuse: 'Rechazar'
      },
      homeScreen: {
        clientCode: 'Código. Cliente',
        client: 'Cliente',
        receiver: 'Receptor',
        createdAt: 'Creado en',
        alterAt: 'Cambiado en',
        labelOrderTitle: 'Solicitudes de pedido',
        labelSearch: 'Buscar por cliente, sku o destinatario',
        search: 'Buscar',
        chemicals: 'Quimicos',
        groupProducts: 'Grupo químico',
        selectAll: 'Todo',
        editOrder: 'Editar Pedidos'
      },
      modalQuantity: {
        title: 'Cantidad por tipo de vehículo',
        columnVehicle: 'TIPO DE VEHÍCULO',
        searchPlaceholder: 'Buscar incoterm, material y vehículo',
        successMessageAdd: '¡Creación completada exitosamente!',
        successMessageUpdate: '¡El cambio se realizó correctamente!',
        errorMessageUpdate: 'Se produjo un error, ¡inténtelo de nuevo!',
        errorMessageAdd: '¡La configuración ya existe para el cliente!',
        btnBack: 'Volver',
        btnSave: 'Guardar',
        btnAdd: 'Agregar',
        validation: 'La cantidad mínima no puede ser mayor que la máxima'
      },
      widgetColumnReport: {
        view: 'Mostrando'
      },
      customersSurveyConfiguration: {
        menu: 'NPS CSAT Feedbacks',
        monthsActive: 'Meses Ativos',
        displayQuantity: 'Número de vistas',
        save: 'Guardar',
        close: 'Cerrar',
        getErrorMessage: 'Error al obtener datos de configuración',
        saveErrorMessage: 'Error al guardar los datos de configuración',
        saveSuccessMessage: '¡Modificaciones realizadas con éxito!',
        january: 'Enero',
        february: 'Febrero',
        march: 'Marzo',
        april: 'Abril',
        may: 'Mayo',
        june: 'Junio',
        july: 'Julio',
        august: 'Agosto',
        september: 'Septiembre',
        october: 'Octubre',
        november: 'Noviembre',
        december: 'Diciembre'
      },
      customersSurveyReportPage: {
        exportXLS: 'Exportar XLS',
        avgMonth: 'Promedio por mes',
        avg: 'Promedio del período',
        customerName: 'Cliente',
        createdAt: 'Creado En',
        jan: 'Ene',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Abr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Ago',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dic'
      },
      holidaysConfiguration: {
        menu: 'Feriados',
        searchFields: 'Buscar por país, tipo, descripción, año, fecha o fábrica'
      },
      callCenter: {
        menu: 'Habla Con Nosotros',
        newTicket: 'Nuevo Atendimento',
        viewTicket: 'Mi petición',
        sector: 'Sector',
        number: 'Servicio No.',
        ticketLevelAll: 'Todos',
        pending: 'Pendiente Unipar',
        served: 'Servido',
        finished: 'Finalizado',
        newPageTitle: 'Envía tu solicitud',
        viewHistoryPageTitle: 'Historial de servicio',
        viewDetailsPageTitle: 'Servicio detalles',
        labelSubject: 'Sujeto',
        labelSubjectSelect: 'Seleccione el sujeto',
        labelPhone: 'Teléfono',
        labelPhonePlaceholder: 'Ingrese el número de contacto',
        labelDescription: 'Mensaje',
        labelDescriptionPlaceholder: 'Ingrese texto',
        labelIsLate: 'Estas Atrasado',
        attachmentsCustomer: 'Archivos adjuntos Cliente',
        attachmentsUnipar: 'Archivos adjuntos Unipar',
        userMessage: 'Mensage enviada',
        uniparReply: 'Respuesta Unipar',
        servedWarningMessage: 'Si no hay ninguna interacción nueva en este servicio dentro de {{daysToFinishTicket}} día, estará finalizado.',
        successMessage: 'Mensaje enviado correctamente',
        errorMessage: 'Error al enviar mensaje',
        servedConfirmMessage: '¿Confirmas la resolución del servicio?',
        servedMessage: 'Servicio resolvido',
        addReply: 'Agregar respuesta',
        serveTicket: 'Resolver servicio',
        errorServedMessage: 'Error al resolver el servicio',
        errorChangeSectorMessage: 'Error al cambiar el sector',
        labelEmail: 'Email',
        labelName: 'Nombre',
        labelCreatedBy: 'Aberto por',
      },
      callCenterReportPage: {
        resolved: 'Resuelto',
        bySector: 'Por sector',
        byTicketLevel: 'Por sujeto'
      },
      bankingAccount: 'Datos Bancarios',
      banking: {
        bank: 'Banco',
        agency: 'Agencia/CBU',
        account: 'Cuenta Corriente',
        pixKey: 'Clave PIX',
        pixKeyType: 'Tipo de clave PIX',
        companyName: 'Empresa',
        companyDocument: 'Documento',
        country: 'País',
        labelActions: 'Acciones',
        new: 'Nueva Cuenta Bancaria',
        edit: 'Editar Cuenta Bancaria',
        active: 'Activo',
        inactive: 'Inactivo',
        search: 'Busca',
        searchBy: 'Buscar por Banco, Agencia, Cuenta o Clave PIX',
        phone: 'Teléfono',
        random: 'Chave aleatória',
        fieldsErrorMessage: 'Por favor ingrese todos los campos obligatorios identificados con *.',
        emailPixError: 'Correo electrónico no válido ingresado en la clave PIX.',
        cnpjPixError: 'CNPJ no válido ingresado en la clave PIX.',
        documentError: 'El documento de la empresa no es válido.'
      },
      success: 'Guardado exitosamente.',
      successTitle: 'Éxito',
      error: 'Se produjo un error al guardar los datos.',
    }
  }
}